import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-selected-indicator',
    templateUrl: './selected-indicator.component.html',
    styleUrls: ['./selected-indicator.component.scss']
})
export class SelectedIndicatorComponent implements OnInit {
    @Input()
    isSelected: boolean;

    constructor() {}

    ngOnInit(): void {}
}
